import React, { useState } from "react";
import Tooltip from "@mui/material/Tooltip";

import VerifiedByBlock from "./verified-by-block";
import LockedBlock from "./locked-block";
import VerificationModal from "./verification-modal";
import { getVerifyBlockers } from "./verification-status";

const VerificationBlock = ({ trip, tripId, onChanged, superAdmin, verificationAdmin, incidentalsIncomplete }) => {
  const [modalMode, setModalMode] = useState(null);

  const canManageVerification = superAdmin || verificationAdmin;

  const verified = !!trip?.verified;
  const locked = !!trip?.lockState?.locked;
  const blockers = getVerifyBlockers(trip, { incidentalsIncomplete });
  const verifiable = blockers.length === 0;

  const verifyButton = (
    <button
      type="button"
      className="base-button evo-gunmetal tv-verify-button w-100"
      disabled={!verifiable}
      onClick={() => setModalMode("verify")}
    >
      Verify Trip
    </button>
  );

  const verifyControl = verifiable ? (
    verifyButton
  ) : (
    <Tooltip
      title={`Complete the following before verifying: ${blockers.join(", ")}`}
    >
      <span className="d-inline-block">{verifyButton}</span>
    </Tooltip>
  );

  const renderBody = () => {
    if (verified) {
      return (
        <VerifiedByBlock
          trip={trip}
          canUnverify={canManageVerification}
          onUnverify={() => setModalMode("unverify")}
        />
      );
    }

    if (locked) {
      return (
        <div className="tv-verification-stack">
          <LockedBlock
            trip={trip}
            canUnlock={canManageVerification}
            onUnlock={() => setModalMode("unlock")}
          />
          {canManageVerification && verifyControl}
        </div>
      );
    }

    return (
      <div className="tv-verification-actions">
        {verifyControl}
        {canManageVerification && (
          <button
            type="button"
            className="base-button btn-danger tv-locked-button"
            onClick={() => setModalMode("lock")}
          >
            Lock Trip
          </button>
        )}
      </div>
    );
  };

  return (
    <div className="tv-block tv-verification">
      <div className="tv-verification-body">{renderBody()}</div>

      <VerificationModal
        isOpen={!!modalMode}
        mode={modalMode || "verify"}
        tripId={tripId}
        onClose={() => setModalMode(null)}
        onSaved={onChanged}
      />
    </div>
  );
};

export default VerificationBlock;
